// Marketing Balance state global — refresh saat login & route change, warning per status subscription.
// Banner warning muncul kalau balance < €5 buat ACTIVE, GRACE & BASIC/INACTIVE
// (buat GRACE/BASIC numpuk di bawah banner MSF).
// Popup "Insufficient Marketing Balance" cuma buat ACTIVE (grace: popup-nya jatah Payment
// Unsuccessful, saldo cukup lewat banner) — sekali per login.
//
// Demo/e2e tanpa BE: sessionStorage.setItem('msfMockBalance', '-50') lalu reload.
import cashbackService from './api/cashbackService';
import { SERVICE_FEE_STATUS } from './subscription';

const STORAGE_KEY = 'skai1MarketingBalance';
const POPUP_SHOWN_KEY = 'skai1BalancePopupShown';
const OPEN_TOPUP_KEY = 'skai1OpenTopup';
export const BALANCE_UPDATED_EVENT = 'balance:updated';
export const OPEN_TOPUP_EVENT = 'balance:open-topup';

const WARN_THRESHOLD = {
  [SERVICE_FEE_STATUS.ACTIVE]: 5,
  [SERVICE_FEE_STATUS.GRACE]: 5,
  [SERVICE_FEE_STATUS.INACTIVE]: 5,
};

export function loadBalance(){
  try{
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw === null ? null : JSON.parse(raw);
  }catch(error){
    return null;
  }
}

export function saveBalance(remaining){
  // Mock menang atas nilai real (demo/e2e) — biar loadData Dashboard gak nimpa skenario.
  // Return nilai final biar caller (kartu Dashboard) selalu konsisten sama banner/popup.
  const mock = sessionStorage.getItem('msfMockBalance');
  const value = mock !== null ? parseFloat(mock) : remaining;
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  window.dispatchEvent(new CustomEvent(BALANCE_UPDATED_EVENT, { detail: value }));
  return value;
}

export async function refreshBalance(){
  const mock = sessionStorage.getItem('msfMockBalance');
  if(mock !== null){
    saveBalance(parseFloat(mock));
    return;
  }

  try{
    const response = await cashbackService.balance({ date: new Date().toISOString().slice(0, 10) });
    if(response && response.code === 'OK' && response.data){
      saveBalance(response.data.remainingBalance ?? 0);
    }
  }catch(error){
    // warning saldo itu best-effort — gagal fetch jangan ganggu app
  }
}

// Format nominal konsisten sama kartu Dashboard (GlobalNumber): minus di DEPAN €,
// desimal ngikut locale (it = koma). Contoh: -€50.00 (en) / -€50,00 (it).
export function formatBalanceAmount(value, lang){
  const v = Number(value) || 0;
  const abs = new Intl.NumberFormat(lang === 'it' ? 'it-IT' : 'en-GB', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Math.abs(v));
  return `${v < 0 ? '-' : ''}€${abs}`;
}

export function shouldWarnBalance(subscription, remaining){
  if(remaining === null || typeof remaining === 'undefined' || !subscription){
    return false;
  }
  const threshold = WARN_THRESHOLD[subscription.serviceFeeStatus];
  return typeof threshold !== 'undefined' && remaining < threshold;
}

export function shouldShowBalancePopup(subscription, remaining){
  if(!subscription || subscription.serviceFeeStatus !== SERVICE_FEE_STATUS.ACTIVE){
    return false;
  }
  return shouldWarnBalance(subscription, remaining) && sessionStorage.getItem(POPUP_SHOWN_KEY) !== 'true';
}

export function markBalancePopupShown(){
  sessionStorage.setItem(POPUP_SHOWN_KEY, 'true');
}

export function clearBalanceState(){
  sessionStorage.removeItem(STORAGE_KEY);
  sessionStorage.removeItem(POPUP_SHOWN_KEY);
  sessionStorage.removeItem(OPEN_TOPUP_KEY);
}

// Semua entry point Top-Up (popup/banner) → dashboard + buka popup top-up existing.
// Flag = buat kasus pindah halaman (Dashboard belum mount); event = buat kasus
// UDAH di dashboard (navigate ke route sama itu no-op, mount gak jalan lagi).
export function startTopupFlow(navigate){
  sessionStorage.setItem(OPEN_TOPUP_KEY, 'true');
  navigate('/admin/dashboard');
  window.dispatchEvent(new CustomEvent(OPEN_TOPUP_EVENT));
}

export function consumeOpenTopupFlag(){
  if(sessionStorage.getItem(OPEN_TOPUP_KEY) === 'true'){
    sessionStorage.removeItem(OPEN_TOPUP_KEY);
    return true;
  }
  return false;
}
